<template>
  <div class="FbComment">
    <div class="mainPanel">
      <div
        class="text-center"
        style="margin-bottom: 30px;"
      >
        <div class="font-bold text-large-4">
          會員的評價
        </div>
        <div>聽聽會員怎麼說</div>
      </div>
      <v-layout>
        <div>
          <iframe
            loading="lazy"
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D100089099457898&tabs=timeline&width=350&height=400&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="300"
            height="260"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          />
        </div>

        <v-flex
          v-if="list.length"
          class="ml-2"
        >
          <v-layout align-center>
            <div class="pb-4">
              <v-btn
                icon
                @click="$refs.listSwiper.$swiper.slidePrev()"
              >
                <v-icon
                  size="40"
                  color="grey"
                >
                  navigate_before
                </v-icon>
              </v-btn>
            </div>
            <v-flex
              style="overflow: hidden;position: relative;width: 780px;"
            >
              <!-- <div
                v-for="i in list.length/4"
                :key="i"
                class="text-xs-center"
              >
                <v-layout>
                  <template v-for="j in 4">
                    <v-flex
                      v-if="list[(i-1)*4+j-1]"
                      :key="list[(i-1)*4+j-1].poid"
                      style="flex:1"
                      class="mx-2 pb-2"
                    >
                      {{ list[(i-1)*4+j-1] }}
                    </v-flex>
                  </template>
                </v-layout>
              </div> -->

              <swiper
                ref="listSwiper"
                :options="listSwiperOptions"
              >
                <swiper-slide
                  v-for="i in Math.ceil(list.length/6)"
                  :key="i"
                  class="text-xs-center"
                >
                  <v-layout
                    wrap
                    justify-space-between
                  >
                    <template v-for="j in swiperViewCount">
                      <div
                        :key="`${i}-${j}`"
                        style="width: 255px;"
                        class="mb-3"
                      >
                        <v-card
                          v-if="list[(i-1)*swiperViewCount+j-1]"
                          flat
                        >
                          <v-card-text style="box-sizing: border-box;">
                            <v-layout
                              align-center
                              class="caption"
                            >
                              <v-avatar
                                size="40"
                                color="blue"
                              >
                                <img
                                  loading="lazy"
                                  decoding="async"
                                  width="40"
                                  height="40"
                                  :src="'data:image/jpeg;base64,'+list[(i-1)*swiperViewCount+j-1].fbcAvatar"
                                  :alt="list[(i-1)*swiperViewCount+j-1].fbcNicname"
                                >
                              </v-avatar>
                              <div class="pl-2">
                                <v-layout style="margin-right: -10px;">
                                  <div
                                    class="font-bold nowrap"
                                    style="color: #385898;"
                                  >
                                    {{ list[(i-1)*swiperViewCount+j-1].fbcNicname }}
                                  </div>
                                  <div class="mx-2">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      src="../images/fb-remember-icon.svg"
                                      width="12"
                                    >
                                  </div>
                                  <div class="grey--text caption line-clamp-1">
                                    推薦了巧巧郎集運
                                  </div>
                                </v-layout>
                                <v-layout>
                                  <div class="caption grey--text">
                                    {{ list[(i-1)*swiperViewCount+j-1].fbcPublicAt | fromNow }}
                                    ·
                                  </div>
                                  <div class="ml-1">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      src="../images/fb-global-icon.svg"
                                      width="10"
                                    >
                                  </div>
                                </v-layout>
                              </div>
                            </v-layout>
                            <div
                              class="line-clamp-2 px-2 mt-2 text-xs-left"
                            >
                              {{ list[(i-1)*swiperViewCount+j-1].fbcContent }}
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </template>
                  </v-layout>
                </swiper-slide>
              </swiper>
            </v-flex>
            <div class="pb-4">
              <v-btn
                icon
                @click="$refs.listSwiper.$swiper.slideNext()"
              >
                <v-icon
                  size="40"
                  color="grey"
                >
                  navigate_next
                </v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data () {
    return {
      // list: ['0', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      list: [],
      swiperViewCount: 6,

      listSwiperOptions: {
        // initialSlide: 1,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loopFillGroupWithBlank: true,
        // autoplay: {
        //   delay: 8000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // pagination: {
        //   el: '.swiper-pagination'
        // },
      },
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const res = await this.$store.dispatch('comment/commentFacebook/search', {
        page: 1,
        pageSize: 6 * 10,
      })
      this.list = res.data.list
    }
  },
}
</script>
<style lang="postcss" scoped>
.FbComment {
  background: #F5F5F5;
  padding: 30px 0 20px 0;
}
</style>
